import {template as tpl, viewModel as MutableCustomer} from "./mutable";
import {global} from "../../../appContext";
import {ICompany, IRouteDefinitionParams} from "../../../index";
import {createErrorMessage} from "../../../util/misc";
import PromiseRequest from "../../../req/PromiseRequest";
import {UPDATING_MESSAGE} from "../../../constants/Language";

export let template: string = tpl;

export class viewModel extends MutableCustomer {

    protected label: string = "Endre kunde";
    protected req_submit: PromiseRequest = global.getPromiseRequest("updatecompany");

    protected msg_submitting = UPDATING_MESSAGE
    protected msg_success = `subject is updated|s:((customer|ac))`

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.initRequest();
    }

    protected override initRequest(): Promise<any> {
        return super.initRequest()
            .then(() => this.__requestRouteData!
                .request()
                .then((data) => { this.data = (data as [ICompany])[0]; })
            )
            .then(() => {
                this.init();
                this.messageData(null);
                this.isReady(true);
            })
            .catch(reason => this.messageData(createErrorMessage(String(reason))))
            ;
    }

}
